import { withNaming } from '@bem-react/classname';

export const cn = withNaming({ n: 'atls-', e: '__', m: '_', v: '_' });
